module.exports = __webpack_public_path__ + "media/images/top/budget_table/hojin_sp_1000-a8320aade79b8f06e66d387d0ac608aa.png";